import TextContent from "@cloudscape-design/components-themed/text-content";

const PasswordPolicy = () => {
  return (
    <TextContent>
      <h4>パスワードの規則</h4>
      <ul>
        <li>12文字以上</li>
        <li>英字（大文字・小文字）、数字、記号の組み合わせ</li>
      </ul>
    </TextContent>
  );
};

export default PasswordPolicy;
